import React from "react";

import { Chip } from "@mui/material";

type OriginatorChipProps = {
  originatorId?: string;
};
const OriginatorChip = ({ originatorId }: OriginatorChipProps) => {
  return originatorId ? <Chip size="small" label={originatorId} /> : <></>;
};
export default OriginatorChip;
